module.exports = __webpack_public_path__ + "static/media/Xira_Terms_of_Service.3bae2345.pdf";